export function FindRoomSVG({ width, height, viewBox }) {
	return (
		<svg
			width={width}
			height={height}
			viewBox={viewBox}
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M6.01398 1.89333L2.42065 4.69333C1.82065 5.16 1.33398 6.15333 1.33398 6.90666V11.8467C1.33398 13.3933 2.59398 14.66 4.14065 14.66H11.8607C13.4073 14.66 14.6673 13.3933 14.6673 11.8533V7C14.6673 6.19333 14.1273 5.16 13.4673 4.7L9.34732 1.81333C8.41398 1.16 6.91398 1.19333 6.01398 1.89333Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M8 11.9933V9.99333"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	)
}
